import React from "react";
import ConfirmLeaveDialog from "components/common/ConfirmLeaveDialog";
import useIsDirty from "views/hooks/useIsDirty";
const WindowLeaveMessage = () => {
  const dirty = useIsDirty();
  return dirty ? /* @__PURE__ */ React.createElement(ConfirmLeaveDialog, { question: "Are you sure you want to leave the page? Any unsaved changes will be lost." }) : null;
};
export default WindowLeaveMessage;
